import { useMatch } from 'react-router-dom';
import { cn } from '@yakit/ui-components';
import { useVDLStore } from '@VDL/store/VDLstore';
import { useMemo } from 'react';

export const VDLToolbarTitle = ({ className }: { className?: string }) => {
  const { homeState, inLevelState } = useVDLStore();

  const matchLevel0 = useMatch(':level0Code/*');

  const title = useMemo(() => {
    if (matchLevel0) {
      return homeState.title ?? inLevelState.title;
    } else {
      return null
    }
  }, [inLevelState, homeState, matchLevel0])

  if (!title) return;

  return (
    <div
      className={cn(
        'line-clamp-1 truncate text-lg font-semibold text-ellipsis',
        className
      )}
    >
      {title}
    </div>
  );
};
